<template>
    <div v-if="notification">
        <v-divider class="grey darken-4"/>
        <div class="pa-12px py-md-14px grey lighten-4">
            <strong class="font-size-16">{{ notification.subject }}</strong>
        </div>
        <v-divider />
        <div class="pa-12px py-md-14px">
            <span class="font-size-14 font-size-md-16"><strong class="font-weight-medium">작성일자 : </strong>{{ $dayjs(notification.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
        </div>
        <v-divider />

        <div class="font-size-14 font-size-md-16 pa-12px py-20px min-h-200px">
            <p v-html="notification.content"></p>
        </div>
        <v-divider />

        <template v-if="prevNotification">
            <div class="pa-12px py-md-14px grey lighten-4">
                <v-row class="row--small font-size-14 font-size-md-16">
                    <v-col cols="auto">
                        <b>이전글</b><v-icon small class="ml-8px">mdi-chevron-right</v-icon>
                    </v-col>
                    <v-col cols="auto">
                        <router-link :to="`/center/notifications/${prevNotification._id}`">{{ prevNotification.subject }}</router-link>
                    </v-col>
                </v-row>
            </div>
            <v-divider />
        </template>
        <template v-if="nextNotification">
            <div class="pa-12px py-md-14px grey lighten-4">
                <v-row class="row--small font-size-14 font-size-md-16">
                    <v-col cols="auto">
                        <b>다음글</b><v-icon small class="ml-8px">mdi-chevron-right</v-icon>
                    </v-col>
                    <v-col cols="auto">
                        <router-link :to="`/center/notifications/${nextNotification._id}`">{{ nextNotification.subject }}</router-link>
                    </v-col>
                </v-row>
            </div>
            <v-divider />
        </template>
    </div>
</template>

<script>
import api from "@/api";
import { mdiChevronRight } from "@mdi/js";
export default {
	components: {
	},
    data() {
        return {
            mdiChevronRight,

            notification: null,

            prevNotification: null,
            nextNotification: null
        };
    },
	mounted() {
		this.init();
	},
	methods: {
		async init() {
            try{
                var { notification, prevNotification, nextNotification } = await api.v1.center.notifications.get({ _id: this.$route.params._notification });
                this.notification = notification;
                this.prevNotification = prevNotification;
                this.nextNotification = nextNotification;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
		}
	},
    watch: {
        $route: {
            deep: true,
            handler(){
                this.init();
            }
        }
    }
}
</script>

<style scoped>
.grow { flex-grow: 1 !important; }
</style>